export const headers = {
    // Accept: 'application/json, text/plain */*',
    'Content-Type': 'multipart/form-data',
  };